import { StudentService } from './../../_services/student.service';
import { Subscription } from './../../_models/subscription';
import { Component, Input, OnInit } from '@angular/core';
import { Student } from 'src/app/_models/student';

@Component({
  selector: 'app-report-student',
  templateUrl: './report-student.component.html',
  styleUrls: ['./report-student.component.css']
})
export class ReportStudentComponent implements OnInit {
  loading=false
  @Input() server_user_id=0
  student = new Student()
  subscription= new Subscription()
  quizarea_syllabus={topics:[],selectedTopics:[]}
  constructor(
    private studentService:StudentService) {

   }
  ngOnInit(): void {
    this.loading=true
     if(this.server_user_id!-0){
       this.studentService.getByUserId(this.server_user_id).subscribe(
        data=>{
          this.student=data
          this.quizarea_syllabus=data['syllabus']
          this.loading=false
        }
       )
     }
   
  }
}